import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { TitleWithIcon } from '../../components/TitleWithIcon/TitleWithIcon.js';
import { useFormSlot } from '../../slots/forms/form-context.js';
import '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';

// TODO: In redesign move create account and optIns to this container.
const ContactDetailsContainer = (props)=>{
    const { getLabel  } = useIntl();
    const { contactDetails  } = useFormSlot({
        onChange: props === null || props === void 0 ? void 0 : props.onChange
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "address-book",
        label: getLabel('checkout.shipping.details.title')
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, contactDetails));
};

export { ContactDetailsContainer };
//# sourceMappingURL=ContactDetailsContainer.js.map
